// src/app/modules/.../redux/actions/WorkflowValidationActions.js

export const GET_WORKFLOW_LEVELS_REQUEST = 'GET_WORKFLOW_LEVELS_REQUEST';
export const GET_WORKFLOW_LEVELS_SUCCESS = 'GET_WORKFLOW_LEVELS_SUCCESS';
export const GET_WORKFLOW_LEVELS_FAIL = 'GET_WORKFLOW_LEVELS_FAIL';

export const SAVE_WORKFLOW_LEVELS_REQUEST = 'SAVE_WORKFLOW_LEVELS_REQUEST';
export const SAVE_WORKFLOW_LEVELS_SUCCESS = 'SAVE_WORKFLOW_LEVELS_SUCCESS';
export const SAVE_WORKFLOW_LEVELS_FAIL = 'SAVE_WORKFLOW_LEVELS_FAIL';

export const SET_WORKFLOW_VALIDATION_LOADING = 'SET_WORKFLOW_VALIDATION_LOADING';

// ============================
// 🎬 ACTION CREATORS
// ============================

export const getWorkflowLevelsRequest = () => ({
    type: GET_WORKFLOW_LEVELS_REQUEST
});

export const getWorkflowLevelsSuccess = (levelsMap) => ({
    type: GET_WORKFLOW_LEVELS_SUCCESS,
    payload: levelsMap // { requestId: level }
});

export const getWorkflowLevelsFail = (error) => ({
    type: GET_WORKFLOW_LEVELS_FAIL,
    error
});

export const saveWorkflowLevelsRequest = (levelsMap) => ({
    type: SAVE_WORKFLOW_LEVELS_REQUEST,
    payload: levelsMap // { requestId: level }
});

export const saveWorkflowLevelsSuccess = () => ({
    type: SAVE_WORKFLOW_LEVELS_SUCCESS
});

export const saveWorkflowLevelsFail = (error) => ({
    type: SAVE_WORKFLOW_LEVELS_FAIL,
    error
});

export const setWorkflowValidationLoading = (loading) => ({
    type: SET_WORKFLOW_VALIDATION_LOADING,
    payload: loading
});
